import { render, staticRenderFns } from "./ThreadReplies.vue?vue&type=template&id=0a57dbdd&scoped=true"
import script from "./ThreadReplies.vue?vue&type=script&setup=true&lang=ts"
export * from "./ThreadReplies.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ThreadReplies.vue?vue&type=style&index=0&id=0a57dbdd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a57dbdd",
  null
  
)

export default component.exports